export default {
    selectMethanolStationByCondition:
        "/gateway/huilianData/methanolStationcs/selectMethanolStationByCondition",
    getMethanolStationByCode:
        "/gateway/huilianData/methanolStationcs/getMethanolStationByCode",
};



// WEBPACK FOOTER //
// ./src/MethanolSite/api.js